<template>
  <img
    src="https://www.samsungfire.com/m/resources/images/front/bg_bn_driver.png"
    height="170"
    width="188"
    alt="car"
    class="-mr-2 !h-12 object-cover object-left"
  />
</template>

<script lang="ts" setup></script>

<style scoped></style>
